import React from 'react';
import MainContainer from '../mainContainer';
import Study from './study';

export default function MorseCode() {
    return (
        <MainContainer>
            <Study />
        </MainContainer>
    );
}
